<template>
  <div class="person" :class="{expanded: expanded || person.description.length < minTextCount}" >
    <div class="header">
      <img class="picture round" :class="person.cls" :src="getImg(person.picture)" />
      <img class="name-tag" :class="{large: person.id == 15}" :src="getImg(person.name)" />
    </div>
    <div v-if="person.description.length > minTextCount" class="content" @click="expanded = true">
      <p class="description" v-html="person.description"></p>
      <button v-if="!expanded" class="btn-expand expand-item">Les mer</button>
    </div>
    <div v-else class="content" >
      <p class="description" v-html="person.description"></p>
    </div>
      <!-- <a class="readmore" v-if="person.id === 1 && expanded" href="https://aftenbladet.no">Les mer om Reidars historie her.</a> -->
  </div>
</template>
<script>
export default {
  props: {
    person: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  methods: {
    getImg(name) {
      return require("@/assets/people/" + name);
    },
  },
  data() {
    return {
      expanded: false,
      minTextCount: 240,
    };
  },
};
</script>
<style lang="scss">
.name-tag {
    height: 50px;
    margin-top:-2rem;
    z-index: 100;
    &.large {
      height: 70px;
    }
}
.person {
  padding: 2rem 0 2rem 0;
  
  display: flex;
  margin: 0 1rem 1rem 1rem;
  flex-direction: column;
  align-items: center;
  color: color("text");
  background-color: color('black-3');

  font-size: 1.2em;
  &.expanded .description {
    overflow: visible;
    height: auto;
    &:after {
      display: none;
    }
  }
  
  &:first-child {
    margin-top: -1rem;
  }
}

.description {
  margin: auto;
  margin-top: 1rem;
  position: relative;
  height: 3em;
  line-height: 1.5;
  overflow: hidden;
  
  z-index: 1;
  padding: 0;
  width: 90%;
  @include desktop () {
    width: 80%;
  }
  &:after {
    content: "";
    text-align: right;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 60%;
    height: 1.4em;
    
    background: linear-gradient(
      to right,
      rgba(80, 80, 80, 0),
      color("black-3") 50%
    );
  }

  p {
    margin: 10px 15px;
  }
}

.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.name {
  margin: 0;
  margin-top: -1em;
  transform: rotate(-3deg);
  z-index: 10;
  padding: 4px 10px;
  font-size: 1.3em;
  font-weight: 400;
  text-align: center;
}
.picture {
  z-index: 3;
  width: 13rem;
}

.round {
  border-radius: 100%;
}
.bg {
    background-color: #fff;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -5px;
  padding: 10px 0;
  font-size: 0.9em;
}
.readmore {
  list-style: none;
  margin: 0 .3rem;
  padding: .6rem .4rem;
  color: color('white');
  text-decoration: none;
  font-size: 0.9em;
        &:hover, &:active, &:focus {
          text-decoration: underline;
          cursor: pointer;
        }    
}
.btn-expand {
  margin: 7.5px 0 0 0;
  padding: 4px 10px;
  width: 100px;
  border: 3px solid color('gray-white');
  font-weight: 600;
  background-color: transparent;
  color: color("gray-white");
  &:hover {
    cursor: pointer;
    color: color('black-2');
    background-color: color('gray-white');
    border: 3px solid transparent;
  }
}

.border {
  border: 1.3px solid #000;
}

.shadow {
  -webkit-box-shadow: 4px 4px 2px 0px rgba(0, 0, 0, 0.54);
  -moz-box-shadow: 4px 4px 2px 0px rgba(0, 0, 0, 0.54);
  box-shadow: 4px 4px 2px 0px rgba(0, 0, 0, 0.54);
}

.border-draw {
  border-radius: 255px 5px 225px 5px/3px 225px 5px 255px;
  border: 1px solid #000;
}
</style>